import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, ROUTER_PATHS, useTabsFormOnly } from "@/shared";
import { SingleTableBoxScene, SingleBoxTableTabsOnly, FormTabsOnly } from "@/shared/components/ui";
import { Tab } from "@mui/material";
import TableSolicitudPreagendamientoTecnicoPymes from "../../shared/componente/table_solicitud_tecnico_pymes/TableSolicitudPreagendamientoTecnicoPymes";

export default function SolicitudTecnicoPlantaExternaPage() {

  const { handleMethodChange, valueTab } = useTabsFormOnly({});

  return (
    <SingleTableBoxScene title={"Solicitud Técnico"}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Solicitud" value={1} {...a11yProps(1)} />
          {/* <Tab label="Agendamiento" value={2} {...a11yProps(2)} /> */}
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Preagendamientos ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <TableSolicitudPreagendamientoTecnicoPymes
          provincia_in="EC-19"
          router_path={ROUTER_PATHS.mantenimientoOperaciones.solicitudTecnicoPymesEditarNav}

        />
      </CustomTabPanel>
      {/* <CustomTabPanel value={valueTab} index={2}>
        <TableSolicitudAgendamientoTecnicoPymes
          provincia="EC-19"
          router_path={ROUTER_PATHS.mantenimientoOperaciones.solicitudTecnicoPymesAgendaEditarNav}

        />
      </CustomTabPanel> */}

    </SingleTableBoxScene>
  );

}